import script from "./Data.vue?vue&type=script&setup=true&lang=js"
export * from "./Data.vue?vue&type=script&setup=true&lang=js"

import "./Data.vue?vue&type=style&index=0&id=9243602e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9243602e"]])

export default __exports__